import Vue from 'vue';
import { SButton, SInput } from "../../../components/ui-components";
import LabelNew from '../../../components/base/vacancies/label-new'
import { formatTimeISO }  from "../../utils/utils"
import PreloaderNew from '../../../components/preloader/preloader-new'

export default Vue.component('vacanciesEdit', {
  components: {
    SButton,
    SInput,
    LabelNew,
    PreloaderNew
  },
  data() {
    return {
      formVacancies: {}
    }
  },
  created() {},
  methods: {
    formatTimeISO,
  }
});
